import { usePassportProvider } from "@/context";
import { QuestTileType } from "@/domain/gems-game/domain";
import { useGetWalletLatestEarnings } from "@/hooks/api";
import { useQuests } from "@/hooks/cms";
import type { Quest } from "@/types";
import { apiFetcher } from "@/utils/fetch";
import { QuestsSection } from "@components/TilesSection/QuestsSection";
import useSWRImmutable from "swr";
import { mainAndSideFilterOptions } from "../utils";

export const MainQuests = ({ scrollToIndex }: { scrollToIndex?: number }) => {
  const { data, isLoading } = useQuests();
  const mainQuests = data?.mainQuests || [];

  const { walletAddress } = usePassportProvider();
  const { latestEarnings } = useGetWalletLatestEarnings(walletAddress);
  const { data: inGameQuests } = useSWRImmutable<{ quests: Quest[] }>(
    "/v1/rewards/quests?category=in_game",
    apiFetcher,
  );
  const quests = inGameQuests?.quests || [];

  const inGameQuestsByGameId = quests.reduce(
    (acc, quest) => {
      if (quest.categories?.includes("testing") || !quest.game_id) {
        return acc;
      }

      acc[quest.game_id] = (acc[quest.game_id] || 0) + 1;
      return acc;
    },
    {} as Record<string, number>,
  );

  const mainQuestsWithCounts = mainQuests.map((quest) => {
    const questCount = quest.gameId ? inGameQuestsByGameId[quest.gameId] : 0;
    return quest.cloneWithOverrides({
      perputualRewardsQuests: questCount,
    });
  });
  return (
    <QuestsSection
      tileType={QuestTileType.MainQuest}
      testId="main-quests"
      title="Main Quests. Eligible for Perpetual Rewards."
      description={
        <>
          Start your Perpetual Rewards journey now. Questions?{" "}
          <a href="/rewards/faq/">Read the FAQ.</a>
        </>
      }
      latestEarnings={latestEarnings}
      filterOptions={mainAndSideFilterOptions}
      data={mainQuestsWithCounts}
      scrollToIndex={scrollToIndex}
      isLoading={isLoading}
    />
  );
};
